export default __webpack_public_path__ + "static/media/refresh-make-2.ee3cd538.png";